/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    alt: PropTypes.string,
    size: PropTypes.oneOf([
        'xxs',
        'xs',
        's',
        'm',
        'l',
        'xl',
        'full',
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
    alt: 'Image',
    componentClass: 'img',
    size: null,
};

const Image = (props) => {
    const classNames = [
        'c-image',
        props.size ? `c-image--${props.size}` : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            alt={props.alt}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        />
    );
};

Image.propTypes = propTypes;

Image.defaultProps = defaultProps;

export default Image;
